"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M10.0754 8.93466L9.7984 8.10166C9.7114 7.84066 9.6034 7.59066 9.4804 7.35066C9.2694 6.93766 9.3644 6.42766 9.7214 6.13266C10.5894 5.41966 11.6874 4.99966 12.8674 4.99966H13.9834V4.18266C13.9834 4.03266 14.2404 3.94666 14.4194 4.03666L17.7604 5.70866C18.0794 5.86966 18.0794 6.13066 17.7604 6.29066L14.4194 7.96366C14.2404 8.05366 13.9834 7.96766 13.9834 7.81766V6.99966H12.8674C11.6194 6.99966 10.5164 7.77466 10.0754 8.93466ZM6.907 12.0655L7.184 12.8985C7.271 13.1595 7.379 13.4095 7.502 13.6495C7.713 14.0625 7.618 14.5725 7.261 14.8675C6.393 15.5805 5.295 16.0005 4.114 16.0005H2.499C2.223 16.0005 2 15.7765 2 15.5005V14.5005C2 14.2235 2.223 14.0005 2.499 14.0005H4.114C5.363 14.0005 6.466 13.2255 6.907 12.0655ZM17.76 14.7091C18.08 14.8691 18.08 15.1311 17.76 15.2911L14.419 16.9631C14.24 17.0531 13.984 16.9681 13.984 16.8181V16.0001H12.868C10.719 16.0001 8.811 14.6231 8.131 12.5811L6.956 9.05106C6.548 7.82606 5.404 7.00006 4.114 7.00006H2.499C2.223 7.00006 2 6.77606 2 6.50006V5.50006C2 5.22406 2.223 5.00006 2.499 5.00006H4.114C6.263 5.00006 8.172 6.37706 8.851 8.41906L10.026 11.9491C10.434 13.1741 11.579 14.0001 12.868 14.0001H13.984V13.1821C13.984 13.0321 14.24 12.9471 14.419 13.0371L17.76 14.7091Z",
    fill: "#727B7F"
  }));
};